import { useCallback, useRef, useState } from 'react'

export interface UseInViewportReturnValue<T extends HTMLElement = HTMLElement> {
  inViewport: boolean
  ref: React.RefCallback<T | null>
}

// TODO: isn't it just useIntersection?
export function useInViewport<T extends HTMLElement = HTMLElement>(): UseInViewportReturnValue<T> {
  const observer = useRef<IntersectionObserver | null>(null)
  const [inViewport, setInViewport] = useState(false)

  const ref: React.RefCallback<T | null> = useCallback(node => {
    if ('IntersectionObserver' in globalThis) {
      if (node && !observer.current) {
        observer.current = new IntersectionObserver(entries =>
          setInViewport(entries.some(entry => entry.isIntersecting)),
        )
      } else {
        observer.current?.disconnect()
      }

      if (node) {
        observer.current?.observe(node)
      } else {
        setInViewport(false)
      }
    }
  }, [])

  return { ref, inViewport }
}
